import { apiClient } from "./browser";
import type { components } from "./generated/wio-veyra-api";
import type { CommandOptions } from "./suppliers";
import type { EventBinding } from "./events";

export type EvaluationSchemas = components["schemas"];
export type EvaluationContext = EvaluationSchemas["EvaluationContext"];
export type EvaluationDetail = EvaluationSchemas["EvaluationDetail"];
export type EvaluationResult = EvaluationSchemas["EvaluationCommandResult"];
export type EvaluationMutationResult =
  EvaluationResult | EvaluationSchemas["AwardDraftResult"];
export type EvaluationMutationInput =
  | EvaluationSchemas["EvaluationSaveInput"]
  | EvaluationSchemas["AwardAllocationInput"]
  | EvaluationSchemas["EvaluationCompleteInput"];
export function updateEvaluation(
  binding: EventBinding,
  eventId: string,
  evaluationId: string,
  action: "work" | "allocation" | "complete",
  body: EvaluationMutationInput,
  options: CommandOptions,
) {
  return apiClient.request<EvaluationMutationResult, EvaluationMutationInput>({
    operation: "UpdateEvaluation",
    method: "POST",
    kind: "command",
    path: evaluationPath(
      binding,
      eventId,
      `/${encodeURIComponent(evaluationId)}/${action}`,
    ),
    body,
    signal: options.signal,
    antiforgeryToken: options.csrfToken,
    idempotencyKey: options.idempotencyKey,
  });
}
export function evaluationPath(
  binding: EventBinding,
  eventId: string,
  suffix = "",
) {
  if (binding.audience !== "workspace")
    throw new Error("Invalid evaluation audience");
  return `/tenants/${encodeURIComponent(binding.tenantId)}/sourcing/${encodeURIComponent(eventId)}/evaluations${suffix}` as const;
}
export function evaluationQuery<T>(
  binding: EventBinding,
  eventId: string,
  suffix: string,
  signal: AbortSignal,
) {
  return apiClient.request<T>({
    operation: "ReadEvaluation",
    method: "GET",
    kind: "query",
    path: evaluationPath(binding, eventId, suffix),
    signal,
  });
}
export function createEvaluation(
  binding: EventBinding,
  eventId: string,
  revisionId: string,
  options: CommandOptions,
) {
  return apiClient.request<
    EvaluationResult,
    EvaluationSchemas["EvaluationCreateInput"]
  >({
    operation: "CreateEvaluation",
    method: "POST",
    kind: "command",
    path: evaluationPath(binding, eventId),
    body: { revisionId },
    signal: options.signal,
    antiforgeryToken: options.csrfToken,
    idempotencyKey: options.idempotencyKey,
  });
}
